import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'

interface TitleWithCountProps {
  title?: string;
  children?: React.ReactNode;
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  className?: string;
}

export default function TitleWithCount (props: TitleWithCountProps) {
  const { title, children, as: Tag = 'h1', className } = props

  return (
    <Tag className={cn(styles.root, className)}>
      {title}
      <span className={styles['root__count']}>{children}</span>
    </Tag>
  )
}
